// extracted by mini-css-extract-plugin
export default {"container":"LocalPasswordRetriever_container__iPnKv","password_container":"LocalPasswordRetriever_password_container__k6uf-","password":"LocalPasswordRetriever_password__9uxyx"};